import apiWithAuth from '../../services/apiWithAuth';

const api = {
    // Announcements
    getAnnouncements: async (shopId, filters = {}) => {
        const params = { shopId, ...filters };
        const response = await apiWithAuth.get('/announcements', { params });
        return response.data;
    },

    getAnnouncementById: async (id) => {
        const response = await apiWithAuth.get(`/announcements/${id}`);
        return response.data;
    },

    createAnnouncement: async (data) => {
        const response = await apiWithAuth.post('/announcements', data);
        return response.data;
    },

    updateAnnouncement: async (id, data) => {
        const response = await apiWithAuth.put(`/announcements/${id}`, data);
        return response.data;
    },

    deleteAnnouncement: async (id) => {
        const response = await apiWithAuth.delete(`/announcements/${id}`);
        return response.data;
    },

    toggleAnnouncementActive: async (id) => {
        const response = await apiWithAuth.patch(`/announcements/${id}/toggle`, {});
        return response.data;
    },

    // File uploads: shopId and userId in URL query so backend always receives them (params can be dropped with FormData)
    uploadImage: async (file, params = {}) => {
        const formData = new FormData();
        formData.append('file', file);
        if (params.shopId != null) formData.append('shopId', params.shopId);
        if (params.userId != null) formData.append('userId', params.userId);

        const query = new URLSearchParams();
        if (params.shopId != null) query.set('shopId', params.shopId);
        if (params.userId != null) query.set('userId', params.userId);
        const url = `/upload/single${query.toString() ? `?${query.toString()}` : ''}`;

        const response = await apiWithAuth.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    uploadVideo: async (file, params = {}) => {
        const formData = new FormData();
        formData.append('files', file);
        if (params.shopId != null) formData.append('shopId', params.shopId);
        if (params.userId != null) formData.append('userId', params.userId);

        const query = new URLSearchParams();
        if (params.shopId != null) query.set('shopId', params.shopId);
        if (params.userId != null) query.set('userId', params.userId);
        const url = `/upload/video${query.toString() ? `?${query.toString()}` : ''}`;

        const response = await apiWithAuth.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    // Shops
    getShops: async () => {
        const response = await apiWithAuth.get('/shops/all');
        return response.data;
    },

    // User-related methods
    getUsers: async () => {
        const response = await apiWithAuth.get('/user-app/users/all');
        return response.data;
    },

    // User Announcements API methods
    getUserAnnouncements: async (userId) => {
        const response = await apiWithAuth.get(`/user-app/announcements?userId=${userId}`);
        return response.data;
    },

    createUserAnnouncement: async (announcementData) => {
        const response = await apiWithAuth.post('/user-app/announcements', announcementData);
        return response.data;
    },

    updateUserAnnouncement: async (id, announcementData) => {
        const response = await apiWithAuth.put(`/user-app/announcements/${id}`, announcementData);
        return response.data;
    },

    deleteUserAnnouncement: async (id) => {
        const response = await apiWithAuth.delete(`/user-app/announcements/${id}`);
        return response.data;
    },

    toggleUserAnnouncementActive: async (id) => {
        const response = await apiWithAuth.patch(`/user-app/announcements/${id}/toggle`, {});
        return response.data;
    },

    // Delivery Boy Announcements API methods
    getDeliveryAnnouncements: async (userId) => {
        const response = await apiWithAuth.get(`/delivery-boy/announcements?userId=${userId}`);
        return response.data;
    },

    createDeliveryAnnouncement: async (announcementData) => {
        const response = await apiWithAuth.post('/delivery-boy/announcements', announcementData);
        return response.data;
    },

    updateDeliveryAnnouncement: async (id, announcementData) => {
        const response = await apiWithAuth.put(`/delivery-boy/announcements/${id}`, announcementData);
        return response.data;
    },

    deleteDeliveryAnnouncement: async (id) => {
        const response = await apiWithAuth.delete(`/delivery-boy/announcements/${id}`);
        return response.data;
    },

    toggleDeliveryAnnouncementActive: async (id) => {
        const response = await apiWithAuth.patch(`/delivery-boy/announcements/${id}/toggle`, {});
        return response.data;
    },

    // Get delivery boys/users for delivery mode
    getDeliveryBoys: async (shopId) => {
        const response = await apiWithAuth.get(`/delivery-boy/user/shop/${shopId}/delivery-boys`);
        return response.data;
    },

    // Shop Members Announcements API methods
    getShopMemberAnnouncements: async (userId) => {
        const response = await apiWithAuth.get(`/partner-shop-members/announcements?userId=${userId}`);
        return response.data;
    },

    createShopMemberAnnouncement: async (announcementData) => {
        const response = await apiWithAuth.post('/partner-shop-members/announcements', announcementData);
        return response.data;
    },

    updateShopMemberAnnouncement: async (id, announcementData) => {
        const response = await apiWithAuth.put(`/partner-shop-members/announcements/${id}`, announcementData);
        return response.data;
    },

    deleteShopMemberAnnouncement: async (id) => {
        const response = await apiWithAuth.delete(`/partner-shop-members/announcements/${id}`);
        return response.data;
    },

    toggleShopMemberAnnouncementActive: async (id) => {
        const response = await apiWithAuth.patch(`/partner-shop-members/announcements/${id}/toggle`, {});
        return response.data;
    }
};

export default api;
